import React, { useState, useEffect } from 'react';

import { Button } from 'reactstrap';
import Http from '../../constants/Http';

const PRICE_TIERS = ['award', 'certificate', 'diploma', 'extended_diploma', 'other'];

const getCourseMinPrice = course => {
  const totals = [];
  PRICE_TIERS.forEach(tier => {
    if (Array.isArray(course[tier])) {
      course[tier].forEach(t => {
        const price = parseFloat(t.price);
        const regFee = parseFloat(t.reg_fee) || 0;
        if (!isNaN(price) && price > 0) totals.push(price + regFee);
      });
    }
  });
  return totals.length ? Math.min(...totals) : null;
};

const Course = ({ course }) => {
  const [minPrice, setMinPrice] = useState(getCourseMinPrice(course));

  // The category-listing endpoint omits the `other` price array, so when no
  // price was found in the initial data, fetch the full course detail (which
  // does include `other`) to fill the gap.
  useEffect(() => {
    if (minPrice != null) return;
    let cancelled = false;
    Http.get(`/course/${course.slug}`)
      .then(res => {
        if (cancelled) return;
        const detail = res.data && res.data.data;
        const fallback = detail ? getCourseMinPrice(detail) : null;
        if (fallback != null) setMinPrice(fallback);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [course.slug, minPrice]);

  const handleApplyClick = e => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = `/application-start?course=${course.slug}`;
  };

  return (
    <a
      href={`/courses/${course.course_type.slug}/${course.slug}`}
      className={'nounderline col-xs-12'}
      title={course.course_type.name}>
      <div style={{ backgroundColor: '#F2F4F6' }} className="course">
        <div className="course-image">
          <img src={course.exam_boards.logo} alt={`${course.exam_boards.name} logo`} />
        </div>
        <div className="course-detail">
          <div
            className="course-title"
            style={{ fontSize: 32, textAlign: 'left' }}>
            {course.course_name}
          </div>
          <p style={{ fontSize: 14, marginBottom: 10, fontWeight: 700 }}>
            {course.course_type.name}
          </p>
          <p
            className="pt-0 CourseDescription"
            dangerouslySetInnerHTML={{
              __html: `${course.summary !== null ? course.summary : course.description.slice(0, 200)}`
            }}
          />
          {minPrice != null && (
            <p className="course-from-price">
              From &pound;{minPrice.toLocaleString('en-GB')}
            </p>
          )}
        </div>
        <div className="button-container">
          <Button>
            View Course <i className="fas fa-chevron-right" />
          </Button>
          <Button className="apply-button" onClick={handleApplyClick}>
            Apply Now
          </Button>
        </div>
      </div>
    </a>
  );
};

export default Course;
